import axios from "axios";

import { ErrorHandler } from "./errorHandler";

const baseURL =
  import.meta.env.VITE_WITH_PROXY === "true"
    ? "/api/public"
    : `${import.meta.env.VITE_BASE_URL}/api/public`;

export const publicApiClient = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

publicApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    ErrorHandler.handle(error);
    return Promise.reject(error);
  },
);

export default publicApiClient;


